import React from "react";
import { Button } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { routes } from "../../Router";

export default function ErrorDetail(): React.JSX.Element {
  /**
   * Screen for displaying an error.
   */
  const { statusCode } = useParams();

  const navigate = useNavigate();

  return (
    <div className="d-flex flex-column align-items-center">
      <div className="d-flex flex-column align-items-center my-5">
        <h3 className="w-100 text-center mb-2">
          <code>{statusCode}</code>
        </h3>
        <p>Er is een fout opgetreden.</p>
      </div>
      <Button
        title="Terug"
        variant="primary"
        className="px-4"
        onClick={() => navigate(routes.root)}
      >
        Terug
      </Button>
    </div>
  );
}
